import React, { useMemo } from 'react';
import { PackageIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
import { BorrowedItemCard } from '../borrowed/BorrowedItemCard';
import { EmptyState } from '../ui/EmptyState';
import { useAppData } from '../../contexts/AppDataContext';
export function BorrowedAlertsSection() {
  const {
    borrowedItems,
    markBorrowedReturned
  } = useAppData();
  const pending = useMemo(() => borrowedItems.filter(item => !item.returned).sort((a, b) => new Date(a.dateBorrowed).getTime() - new Date(b.dateBorrowed).getTime()).slice(0, 3), [borrowedItems]);
  return <section data-id="element-62" data-mp="10g6757zbrx88">
      <SectionHeader icon={PackageIcon} iconClassName="bg-amber-50 text-amber-600" title="Borrowed items" linkTo="/borrowed" data-id="element-63" data-mp="10cs7i7i1q24h" />
      {pending.length === 0 ? <EmptyState icon={PackageIcon} title="Nothing borrowed" description="Everything you've lent out has been returned." data-id="element-64" data-mp="2bsp5el7v3wdu" /> : <div className="space-y-2" data-id="element-65" data-mp="26x1jqfsl9ld3">
          {pending.map(item => <BorrowedItemCard key={item.id} item={item} onMarkReturned={() => markBorrowedReturned(item.id)} compact data-id="element-66" data-mp="3agjycnolpex2" />)}
        </div>}
    </section>;
}